$(function () {
    checkCookiePolicy();
});

function checkCookiePolicy() {
    var savedCookiePolicyResponse = localStorage.getItem("acceptedCookiePolicy");
    if (!savedCookiePolicyResponse || savedCookiePolicyResponse !== "true") {
        $(".cookie-policy-message-container").show();
    }
}

window.acceptCookiePolicy = function () {
    localStorage.setItem("acceptedCookiePolicy", "true");
    $(".cookie-policy-message-container").slideUp("slow");
};